<h2 mat-dialog-title>Select Task Type</h2>

<div class="dialog-body">
  <p class="question">How do you want to proceed?</p>

  <div
    class="option"
    [class.selected]="selectedType === 'task'"
    (click)="select('task')"
  >
    <div class="option-left">
      <mat-icon fontSet="material-icons-outlined">sensors</mat-icon>
      <div class="label-block">
        <div class="title">Sensor-Based
        </div>
        <div class="subtitle">
          Pick sensors → Attach feed(s) → Answer delivered
        </div>
      </div>
    </div>
    <mat-radio-button
      color="primary"
      [checked]="selectedType === 'task'"
    ></mat-radio-button>
  </div>

  <div
    class="option"
    [class.selected]="selectedType === 'feed'"
    (click)="select('feed')"
  >
    <div class="option-left">
     <img
     src="../../../assets/images/sat-earth.png"
     alt="Feed"
     class="custom-option-icon"
     />
      <div class="label-block">
        <div class="title">
          Question-Based
          <img
            src="../../../assets/images/beta-version.png"
            alt="Beta"
            class="beta-icon"
          />
        </div>
        <div class="subtitle">
          Ask a question → Platform tasks → Answer delivered
        </div>
      </div>
    </div>
    <mat-radio-button
      color="primary"
      [checked]="selectedType === 'feed'"
    ></mat-radio-button>
  </div>
</div>

<div mat-dialog-actions align="end" class="btns">
  <button mat-stroked-button (click)="onClose()" class="custom-button">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!selectedType" (click)="continue()">
    Continue
  </button>
</div>
